import AsianFooter from "app/screens/AsianEventsScreen/components/AsianFooter/AsianFooter";
import {
  AsianCompetitionFilterTypes,
  competitionListTimeEnum,
} from "app/utils/const";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
type Props = {
  selectedCompetitionType: string;
  bookmarksTotal: number;
  bookmarksOnly: boolean;
  favouritesOnly: boolean;
  isUserLoaded: boolean;
  time: string;
}; // test

class GetNoEventsContent extends Component<Props> {
  render(): React.ReactElement<React.ComponentProps<"div">, "div"> {
    // For Asian view popular, today etc will depend on user's time preference, which is not implemented yet
    // Probably need to refactor these messages then
    const {
      selectedCompetitionType,
      bookmarksTotal,
      bookmarksOnly,
      favouritesOnly,
      isUserLoaded,
      time,
    } = this.props;
    let message = isUserLoaded ? (
      <FormattedMessage tagName="span" id="events-no-active-events-selection" />
    ) : (
      ""
    );

    // no live events
    if (
      !favouritesOnly &&
      !bookmarksOnly &&
      selectedCompetitionType === AsianCompetitionFilterTypes.LIVE
    ) {
      message = <FormattedMessage tagName="span" id="events-no-live-events" />; // No events today
    } else if (
      !favouritesOnly &&
      !bookmarksOnly &&
      time === competitionListTimeEnum.TODAY &&
      selectedCompetitionType === AsianCompetitionFilterTypes.DATE
    ) {
      message = <FormattedMessage tagName="span" id="events-no-events-today" />; // No active events
    } else if (
      !favouritesOnly &&
      !bookmarksOnly &&
      time === competitionListTimeEnum.EARLY &&
      selectedCompetitionType === AsianCompetitionFilterTypes.DATE
    ) {
      message = (
        <FormattedMessage
          tagName="span"
          id="events-no-active-events-selection"
        />
      ); // no event for next 24 hours
    } else if (
      !favouritesOnly &&
      !bookmarksOnly &&
      selectedCompetitionType === AsianCompetitionFilterTypes.POPULARITY
    ) {
      message = (
        <FormattedMessage tagName="span" id="events-no-events-24-hours" />
      ); // no favourites
    } else if (!this.props.bookmarksOnly && favouritesOnly) {
      message = <FormattedMessage tagName="span" id="favourites-no-events" />; // no bookmarked leagues have events
    } else if (!favouritesOnly && bookmarksOnly && bookmarksTotal !== 0) {
      message = (
        <FormattedMessage
          tagName="span"
          id="events-no-active-events-selection"
        />
      ); // no  leagues bookmarked
    } else if (!favouritesOnly && bookmarksOnly && bookmarksTotal === 0) {
      message = <FormattedMessage tagName="span" id="events-no-bookmarks" />;
    }

    //
    return (
      <div className="competitions-screen__list__empty-list">
        {message}
        <AsianFooter className={"no-content"} />
      </div>
    );
  }
}

export default GetNoEventsContent;
